import script from "./NouvelleView.vue?vue&type=script&setup=true&lang=js"
export * from "./NouvelleView.vue?vue&type=script&setup=true&lang=js"

import "./NouvelleView.vue?vue&type=style&index=0&id=39061bfb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39061bfb"]])

export default __exports__